import axios from 'axios'
import { getToken, isJSON, decryptAES, encryptAES } from './index'

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
  headers: { 'X-Custom-Header': 'wtcs-cust-client' }
})
const whiteList = ['/sys/getTouristToken', '/sys/refreshTouristToken']
http.interceptors.request.use(
  (config) => {
    let token = getToken()
    let url = config.url.replace(config.baseURL, '')
    let requestKey = localStorage.getItem('requestKey')
    if (token && !whiteList.includes(url)) {
      config.headers.Authorization = encryptAES(`${'' + token}|${requestKey}|ABC123`)
    }
    let robotId = localStorage.getItem("robotId");
    if (robotId !== null) {
        config.headers["robotId"] = robotId;
    }
    if (!['/sys/oss/upload', '/sys/getTouristToken'].includes(url)) {
      if (!config.data) {
        config.data = {}
      }
      config.data.requestKey = requestKey
      config.data = { encodeParam: encryptAES(`${JSON.stringify(config.data)}`) }
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

http.interceptors.response.use((response) => {
  let str = decryptAES(response.data)
  if (isJSON(str)) {
    response.data = JSON.parse(str)
  }
  return response.data
})

export { http }
